import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdminFamily, DetachResult, StructureEvent } from '../models/branch-family.model';

/**
 * Business families for platform support (specs/branches SCR-B9). Read the family and its history,
 * detach a branch with a reason. There is no link call on purpose: support never links businesses (B3).
 */
@Injectable({ providedIn: 'root' })
export class BranchAdminService {
  private readonly baseUrl = environment.subscriptionApiUrl + '/api/admin/branches';

  constructor(private http: HttpClient) {}

  getFamily(businessId: string): Observable<AdminFamily> {
    return this.http.get<AdminFamily>(`${this.baseUrl}/${encodeURIComponent(businessId)}/family`);
  }

  getHistory(businessId: string): Observable<StructureEvent[]> {
    return this.http.get<StructureEvent[]>(`${this.baseUrl}/${encodeURIComponent(businessId)}/history`);
  }

  detach(branchId: string, reason: string): Observable<DetachResult> {
    return this.http.post<DetachResult>(`${this.baseUrl}/${encodeURIComponent(branchId)}/detach`, { reason });
  }
}
